import React, { createContext, FC, ReactNode, useMemo, useState } from 'react';

export const DEFAULT_NEDBETALINGSTID = 30;
export const DEFAULT_MARKEDSRENTE = 6.0;
export const DEAFULT_LAANEBELOP = 2000000;

export interface Laaneparam {
    aarsinntekt: number | undefined;
    antallBarn: string;
    antallBiler: string;
    antallLaantakere: string;
    gjeld: number | undefined;
    rente: number;
    nedbetalingstid: number;
    laanebeloep: number;
}

export interface AppContextType {
    laaneparam: Laaneparam;
    setLaaneparam: (laaneparam: Laaneparam) => void;
}

export const AppContext = createContext<AppContextType>({
    laaneparam: {
        aarsinntekt: undefined,
        antallBarn: '',
        antallBiler: '',
        antallLaantakere: '',
        gjeld: undefined,
        rente: DEFAULT_MARKEDSRENTE,
        nedbetalingstid: DEFAULT_NEDBETALINGSTID,
        laanebeloep: DEAFULT_LAANEBELOP,
    },
    setLaaneparam: (laaneparam: Laaneparam) => {
        return laaneparam;
    },
});

interface Props {
    children: ReactNode;
}

const KalkulatorState: FC<Props> = ({ children }) => {
    const [laaneparam, setLaaneparam] = useState<Laaneparam>({
        aarsinntekt: undefined,
        antallBarn: '',
        antallBiler: '',
        antallLaantakere: '',
        gjeld: undefined,
        rente: DEFAULT_MARKEDSRENTE,
        nedbetalingstid: DEFAULT_NEDBETALINGSTID,
        laanebeloep: DEAFULT_LAANEBELOP,
    });

    const state = useMemo(
        () => ({
            laaneparam,
            setLaaneparam,
        }),
        [laaneparam, setLaaneparam],
    );

    return <AppContext.Provider value={state}>{children}</AppContext.Provider>;
};

export default KalkulatorState;
